export const normalizeTaskSections = (items, fallbackLabel = null) => {
  if (!Array.isArray(items) || items.length === 0) return [];

  const hasSections = items.every(
    (item) => item && typeof item === 'object' && Array.isArray(item.tasks)
  );

  if (hasSections) {
    return items
      .map((section) => ({
        label: section.label_date ?? fallbackLabel,
        tasks: section.tasks ?? [],
      }))
      .filter((section) => section.tasks.length > 0);
  }

  return [
    {
      label: fallbackLabel,
      tasks: items,
    },
  ];
};

export const getResponseTaskSections = (response, fallbackLabel = null) =>
  normalizeTaskSections(
    response?.tasks ?? response?.pending ?? response ?? [],
    fallbackLabel
  );

export const appendTasks = (currentTasks = [], incomingTasks = []) => {
  const currentTaskIds = new Set(currentTasks.map((task) => task.id));
  const newTasks = incomingTasks.filter((task) => {
    if (currentTaskIds.has(task.id)) return false;

    currentTaskIds.add(task.id);
    return true;
  });

  return [...currentTasks, ...newTasks];
};

export const appendTaskSections = (
  currentSections = [],
  incomingSections = []
) => {
  if (!currentSections.length) return incomingSections;
  if (!incomingSections.length) return currentSections;

  const nextSections = currentSections.map((section) => ({
    ...section,
    tasks: [...(section.tasks ?? [])],
  }));

  incomingSections.forEach((incomingSection) => {
    const sectionIndex = nextSections.findIndex(
      (section) => section.label === incomingSection.label
    );

    if (sectionIndex === -1) {
      nextSections.push(incomingSection);
      return;
    }

    nextSections[sectionIndex] = {
      ...nextSections[sectionIndex],
      tasks: appendTasks(
        nextSections[sectionIndex].tasks,
        incomingSection.tasks
      ),
    };
  });

  return nextSections;
};
